module.exports = __webpack_public_path__ + "img/shoe1.5f1a4ac3.png";